var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareRunAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29069 10.7071C7.90017 10.3166 7.90017 9.68337 8.29069 9.29287C8.68122 8.90238 9.31438 8.90238 9.70491 9.29287L11.7049 11.2929C12.0954 11.6834 12.0954 12.3166 11.7049 12.7071L9.70491 14.7071C9.31438 15.0976 8.68122 15.0976 8.29069 14.7071C7.90017 14.3166 7.90017 13.6834 8.29069 13.2929L9.58358 12L8.29069 10.7071Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V5.99999C22 3.79086 20.2091 2 18 2H6C3.79086 2 2 3.79086 2 6V18ZM20 18C20 19.1046 19.1046 20 18 20H10.05V19.9982H7.94998V20H6C4.89543 20 4 19.1046 4 18V10.05H4.01306V7.94998H4V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V7.94998H19.9871V10.05H20V18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.963 10.7071C12.5725 10.3166 12.5725 9.68337 12.963 9.29287C13.3535 8.90238 13.9867 8.90238 14.3772 9.29287L16.3772 11.2929C16.7677 11.6834 16.7677 12.3166 16.3772 12.7071L14.3772 14.7071C13.9867 15.0976 13.3535 15.0976 12.963 14.7071C12.5725 14.3166 12.5725 13.6834 12.963 13.2929L14.2559 12L12.963 10.7071Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareRunAll);
export default __webpack_public_path__ + "static/media/square_run_all.1993f5e58005b885b8489c2d37bc71ef.svg";
export { ForwardRef as ReactComponent };